import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DriverService as CLARADriverService, InterestedDriver, ProviderSelectionDetail } from '@uzurv/clara';
import { DateFormatConstants, isNullOrUndefined } from '@uzurv/core';
import moment from 'moment-timezone';

@Component({
  selector: 'app-select-provider-list-item',
  templateUrl: './select-provider-list-item.component.html',
  styleUrls: ['./select-provider-list-item.component.scss']
})
export class SelectProviderListItemComponent {
  @Input()
  providerSelectionDetail: ProviderSelectionDetail;

  @Input()
  pickupTime: string;

  @Input()
  timeZone: string;

  @Output()
  providerSelected: EventEmitter<ProviderSelectionDetail> = new EventEmitter();

  constructor(private claraDriverService: CLARADriverService) {}

  get isUninterestedProvider(): boolean {
    return isNullOrUndefined(this.providerSelectionDetail.interestedDriver) || this.providerSelectionDetail.providerIgnoringRide;
  }

  /**
   * Returns whether or not the provider has proposed a new time.
   */
  get isProposedTime(): boolean {
    if (isNullOrUndefined(this.providerSelectionDetail?.interestedDriver)) {
      return false;
    }

    return this.providerSelectionDetail.interestedDriver.proposingNewPickupTime;
  }

  /**
   * Returns the text for the select button (whether or not it's original time or proposed time).
   */
  get selectionText(): string {
    if (this.isProposedTime) {
      return moment.tz(this.providerSelectionDetail.interestedDriver.proposedPickupTime, this.timeZone).format(DateFormatConstants.TIME);
    }
    return this.pickupTime;
  }

  /**
   * Returns the color for the select button (whether it's an interested or uninterested provider).
   */
  get selectButtonColor(): string {
    if (this.isUninterestedProvider) {
      return '';
    } else {
      return 'primary';
    }
  }

  /**
   * Emit provider selected event when select button is clicked.
   */
  selectProvider(): void {
    this.providerSelected.emit(this.providerSelectionDetail);
  }
}
